import React from "react";

const SellerPrmContext = React.createContext();

export default SellerPrmContext;